<template>
   <!--FAQ One Start-->
   <section class="faq-one faq-two">
            <!-- <div class="faq-one-shape-1" style="background-image: url(assets/images/shapes/faq-one-shape-1.png);"></div>
            <div class="faq-one-bg" style="background-image: url(assets/images/other/lago.jpg);"></div> -->
            <div class="faq-one-bg"></div>
            <div class="container">
                <div class="row">
                    
                    <div class="col-xl-4 col-lg-4">
                         <div class="faq-one__right">
                            <div class="accrodion-grp" data-grp-name="faq-one-accrodion">
                                <div class="accrodion active box-border">
                                    <div class="accrodion-title">
                                        <h3 style="color: #2c3e50">Nuestra misión</h3>
                                    </div>
                                    <div class="accrodion-content" >
                                        <div class="inner justifi">
                                            <p>Brindar servicios integrales en instalaciones eléctricas e hidráulicas, garantizando 
                                                altos estándares de calidad y excelencia en cada proyecto. Nos comprometemos además con el 
                                                desarrollo humano y profesional de nuestros colaboradores, promoviendo 
                                                un ambiente de trabajo responsable, innovador y orientado a la satisfacción de nuestros clientes.</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                            </div>      
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-4">
                        <div class="faq-one__right">
                              <div class="accrodion-grp" data-grp-name="faq-one-accrodion">
                                <div class="accrodion box-border"  style=" padding-bottom: 50px !important;">
                                    <div class="accrodion-title">
                                        <h3 style="color: #2c3e50;">Nuestra visión</h3>
                                    </div>
                                    <div class="accrodion-content">
                                        <div class="inner justifi">
                                            <p>Ser reconocidos como una de las principales empresas en brindar servicios integrales de instalaciones
                                                 eléctricas e hidráulicas, destacándonos por nuestra sólida estructura organizacional, 
                                                 innovación constante y la experiencia técnica y compromiso de nuestro equipo de colaboradores. 
                                                  Nos esforzamos por ofrecer soluciones de alta calidad que 
                                                superen las expectativas de nuestros clientes y contribuyan al desarrollo sostenible de la comunidad.</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                              </div>      
                          </div>
                    </div>

                    <div class="col-xl-4 col-lg-4">
                         <div class="faq-one__right">
                            <div class="accrodion-grp" data-grp-name="faq-one-accrodion">
                                <div class="accrodion active box-border">
                                    <div class="accrodion-title">
                                        <h3 style="color: #2c3e50">Nuestros valores</h3>
                                    </div>
                                    <div class="accrodion-content" >
                                        <div class="inner center">
                                            <p class="p-text">Integridad</p>
                                            <p class="p-text">Compromiso</p>
                                            <p class="p-text">Trabajo en equipo</p>
                                            <p class="p-text">Responsabilidad</p>
                                            <p class="p-text">Rapidez</p>
                                            <p class="p-text">Eficacia</p>
                                        </div><!-- /.inner -->
                                    </div>
                                </div>
                            </div>      
                        </div>
                    </div>


                    <!-- <div class="col-xl-4 col-lg-4">
                        <div class="faq-one__left box-border">
                            class="section-title text-left" 
                            <div class="accrodion-title ">
                             <span class="section-title__tagline">Recently asked questions</span> 
                                <h5 class="accrodion-title" style="font-size: calc(1.275rem + .3vw); color: #2c3e50;">Nuestros valores
                                </h5>
                            </div>
                            <div>
                                <span class="accrodion-title color-v">Integridad</span>
                            </div>
                            <div>
                                <span class="accrodion-title color-v">Compromiso</span>
                            </div>
                            <div>
                                <span class="accrodion-title color-v">Trabajo en equipo</span>
                            </div>
                            <div>
                                <span class="accrodion-title color-v">Responsabilidad</span>
                            </div>
                            <div>
                                <span class="accrodion-title color-v">Rapidez</span>     
                            </div>
                            class= section-title__tagline
                            <div>
                                <span class="color-v">Eficacia</span> 
                            </div>
                            
                            <p class="faq-one__text-1">Integridad</p>
                            <p class="faq-one__text-1">Compromiso</p>
                            <p class="faq-one__text-1">Trabajo en equipo</p>
                            <p class="faq-one__text-1">Responsabilidad</p>
                            <p class="faq-one__text-1">Rapidez</p>
                            <p class="faq-one__text-1">Eficacia</p> 

                           <a href="faq.html" class="thm-btn faq-one__btn">Learn how to get help</a> 
                        </div>
                    </div> -->

                </div>
            </div>
        </section>
        <!--FAQ One End-->

</template>
        <style>
        .justifi{
            text-align: justify;
        }
        .center{
            text-align: center;
        }
        .color-v{
            color: #2c3e50 !important;
            font-size: 18px;
        }

        .box-border{
            border: solid 1px #2c3e5049;
            border-radius: 15px;
            padding: 20px;
        }

        .p-text{
            font-size: 18px;
        }


        @media only screen and (max-width: 1024px){
            .p-text {
                margin-bottom: 10px;
            }
        }

        @media only screen and (max-width: 1024px){
            .box-border {
                margin-bottom: 20px;
            }

            .faq-two {
                padding: 90px 0 90px;
            }
        }

        
</style>
<script>
</script>